import appAxios from "../services/axios";

export const loginUserToken = async ({ tokenLogin }) => {
  const resp = await appAxios.post("/api/user/login", {
    tokenLogin: tokenLogin,
  });
  return resp.data;
};

export const getCurrentUser = async () => {
  const resp = await appAxios.get("/api/user/current");
  return resp.data;
};

export const logoutUserRequest = async () => {
  const resp = await appAxios.post("/api/user/logout");
  return resp.data;
};
